export default __webpack_public_path__ + "static/media/b-check.87694254.svg";